module.exports = __webpack_public_path__ + "img/Swiss-Air.dba36e26.webp";